<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h1"><a id="page_3"></a><strong>R<span class="small">ANDOM</span> A<span class="small">CTS</span> <em>of</em> SENSELESS VIOLENCE</strong></h1>
<p class="author"><strong>Jack Womack</strong></p>
<p class="pubimage"><img alt="Image" src="images/pub.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?313d798e